import { useContext } from 'react'
import { TrackingContext } from 'Contexts/TrackingContext/TrackingContext'
import useGlobalPrivacyControl from "Hooks/useGlobalPrivacyControl";

const useBloomreach = () => {
  
  const { isGpcEnabled } = useGlobalPrivacyControl()
  const { bloomreachInitialPageView, bloomreachVirtualPageView, bloomreachEvent } = useContext(TrackingContext)

  const sendBloomreachInitialPageView = (ev) => {
    if(!isGpcEnabled) {
      if(!ev.view_id){
        ev.view_id = 'BASE'
      }
      bloomreachInitialPageView(ev)
    }
  }

  const sendBloomreachVirtualPageView = (ev) => {
    if(!isGpcEnabled) {

      if(!ev.view_id){
        ev.view_id = 'BASE'
      }
      bloomreachVirtualPageView(ev)
    }
  }

  const sendBloomreachEvent = (ev) => {
    if(!isGpcEnabled) {
      if(!ev.ref && window != 'undefined'){
        ev.ref = window.location.href;
      }
      if(!ev.view_id){
        ev.view_id = 'BASE'
      }
      bloomreachEvent(ev)
    }
  }




  return { sendBloomreachInitialPageView, sendBloomreachVirtualPageView, sendBloomreachEvent }
}

export default useBloomreach
